import { getOffsetRect } from "../../../lib/utils/styling";
import DropHint from './base';
export default class NoopDropHint extends DropHint {
  constructor() {
    super(...arguments);
    this.hintClassName = 'isBlockHint';
  }
  getRect() {
    var _this$renderer$getRef;
    const {
      rect,
      compPath
    } = this.config;
    if (rect) return rect;
    const refElement = (_this$renderer$getRef = this.renderer.getRefByPath(compPath)) === null || _this$renderer$getRef === void 0 ? void 0 : _this$renderer$getRef.$el;
    if (!refElement) return null;
    const {
      x: x0,
      y: y0,
      width: w0,
      height: h0
    } = getOffsetRect(refElement, this.ownerSlot.slotContainerElement);
    return {
      x: x0,
      y: y0,
      width: w0,
      height: h0
    };
  }
  getDescription() {
    return this.config.description;
  }
  getRelatedCompPath() {
    return this.config.compPath;
  }
  execute() {
    // nothing
  }
}
//# sourceMappingURL=NoopDropHint.js.map
